module.exports = __webpack_public_path__ + "img/assign-blue.9ba338a2.svg";